function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("filter", null, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.282353 0 0 0 0 0.662745 0 0 0 0 0.627451 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("rect", {
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1645,
  height: 1790,
  fill: "#FBFBFB"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-9)",
  xlinkHref: "#path-8",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-8",
  fill: "#FFF"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-11)",
  xlinkHref: "#path-10",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-10",
  fill: "#FFF"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 414,
  width: 24,
  height: 24
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  fill: "#555150"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.3 437.4C47.1 437.4 46.9 437.3 46.7 437.2L45.3 435.5C45.1 435.2 44.9 435.1 44.5 435.1L43.6 435C43.3 435 43 435.1 42.8 435.3L41.3 436.8C41 437.1 40.4 437.1 39.5 436.7 38.2 436 38.3 435.6 38.3 435.5L38.5 433.3C38.5 433 38.4 432.7 38.2 432.4L37.6 431.7C37.4 431.5 37.1 431.4 36.8 431.4L34.8 431.4C34.3 431.4 33.9 430.9 33.5 430 33.1 428.7 33.4 428.4 33.5 428.3L35.2 426.9C35.5 426.7 35.6 426.4 35.6 426.1L35.6 425.2C35.7 424.9 35.6 424.5 35.4 424.3L33.9 422.9C33.6 422.5 33.6 421.9 34 421.1 34.6 419.7 35 419.8 35.2 419.8L37.4 420.1C37.7 420.1 38 420 38.3 419.8L38.9 419.2C39.2 419 39.3 418.7 39.3 418.3L39.3 416.3C39.3 415.8 39.8 415.4 40.7 415.1 42 414.6 42.3 414.9 42.4 415.1L43.8 416.8C44 417 44.3 417.2 44.6 417.2L45.5 417.2C45.8 417.2 46.1 417.1 46.4 416.9L47.8 415.4C48.2 415.1 48.8 415.1 49.7 415.5 50.9 416.1 50.9 416.5 50.9 416.7L50.6 418.9C50.6 419.2 50.7 419.5 50.9 419.8L51.5 420.4C51.7 420.7 52 420.8 52.4 420.8L54.4 420.8C54.9 420.8 55.3 421.3 55.6 422.2 56.1 423.5 55.8 423.8 55.6 423.9L53.9 425.3C53.7 425.5 53.5 425.8 53.5 426.1L53.5 426.1 53.5 427C53.5 427.3 53.6 427.6 53.8 427.9L55.3 429.3C55.6 429.7 55.6 430.3 55.2 431.2 54.5 432.4 54.1 432.4 54 432.4L51.8 432.1C51.5 432.1 51.2 432.2 51 432.4L50.3 433C50.1 433.2 49.9 433.5 49.9 433.9L49.9 435.9C49.9 436.4 49.5 436.8 48.5 437.2 48.1 437.3 47.7 437.4 47.3 437.4L47.3 437.4ZM43.6 433.9L43.7 433.9 44.6 433.9C45.2 433.9 45.8 434.2 46.2 434.7L47.5 436.2C47.9 436.1 48.3 436 48.7 435.7L48.7 433.9C48.7 433.3 49 432.6 49.4 432.2L50.1 431.6C50.6 431.2 51.2 431 51.9 431.1L53.8 431.3C54 430.9 54.2 430.5 54.3 430.1L53 428.8C52.5 428.3 52.3 427.7 52.3 427L52.3 426.1C52.4 425.5 52.7 424.9 53.2 424.5L54.7 423.3C54.6 422.8 54.5 422.4 54.3 422L52.4 422C51.7 422 51.1 421.7 50.7 421.2L50.1 420.6C49.6 420.1 49.4 419.5 49.5 418.8L49.7 416.9C49.4 416.7 49 416.5 48.6 416.4L47.2 417.7C46.7 418.2 46.1 418.4 45.4 418.4L44.6 418.3C43.9 418.3 43.3 418 42.9 417.5L41.8 416C41.3 416.1 40.9 416.2 40.5 416.4L40.5 418.3C40.5 419 40.3 419.6 39.8 420L39.1 420.6C38.7 421 38 421.3 37.4 421.2L35.4 421C35.2 421.3 35 421.7 34.9 422.1L36.2 423.5C36.6 424 36.9 424.6 36.8 425.3L36.8 426.1C36.8 426.8 36.5 427.4 36 427.8L34.4 429C34.5 429.4 34.7 429.8 34.9 430.2L36.8 430.2C37.4 430.2 38 430.5 38.5 431L39.1 431.6C39.5 432.1 39.7 432.8 39.6 433.4L39.4 435.3C39.8 435.6 40.2 435.8 40.6 435.9L42 434.6C42.4 434.1 43 433.9 43.6 433.9ZM44.6 430.8C42.7 430.8 41 429.6 40.3 427.9 39.6 426.2 40 424.2 41.3 422.8 42.6 421.5 44.6 421.1 46.4 421.8 48.1 422.5 49.2 424.2 49.2 426.1 49.2 428.7 47.1 430.8 44.6 430.8L44.6 430.8ZM44.6 422.6C42.6 422.6 41.1 424.2 41.1 426.1 41.1 428.1 42.6 429.6 44.6 429.6 46.5 429.6 48.1 428.1 48.1 426.1 48.1 425.2 47.7 424.3 47.1 423.6 46.4 423 45.5 422.6 44.6 422.6Z"
}));

var SvgUstawieniaSider = function SvgUstawieniaSider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -414)"
  }, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#415467",
      opacity: 0.8
    }
  }), _ref6, _ref7, _ref8, _ref9)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUstawieniaSider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UstawieniaSider.68ca3763.svg";
export { ForwardRef as ReactComponent };